/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React, { Component } from 'react';
import Skeleton from 'react-loading-skeleton';
import Filter from '../../components/Filter';
import './styles.scss';
import lookinMan from '../../assets/feed/lookinMan.svg';
import SkeletonCard from '../../components/Skeleton/component';
import LoadingCard from '../../components/LoadingCard/component';
import Check from '../../assets/feed/check.svg';
import DefaultProfile from '../../assets/profile/default-profile-icon.svg';

export class Feed extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  async componentDidMount() {
    await this.props.getUsers(this.props.user.userType);
    await this.props.getMatches();
    this.setState({ loading: false });
    const promises = Object.entries(this.props.users).map(([email, user]) => {
      return this.props.getProfilePhoto(
        user.answers?.profile_photo?.answer,
        email,
      );
    });
    const personalPhoto = this.props.user.answers.profile_photo?.answer;
    if (!(personalPhoto || '').startsWith('http')) {
      promises.push(this.props.getProfilePhoto(personalPhoto));
    }
    await Promise.all(promises);
  }

  // explicitly defining this function makes it easier to test
  goToFeed = () => {
    this.props.history.push('/feed');
  }

  getFeedProfilePhoto = (url, tags) => {
    const tagHTML = (
      <div className="tags-container">
        {tags.map(tag => (
          <div className="tag" key={tag}>{tag}</div>
        ))}
      </div>
    );

    if (!url) {
      return (
        <div
          className="profile-img-container"
          style={{ backgroundImage: `url(${DefaultProfile})` }}
        >
          {tagHTML}
        </div>
      );
    }
    if (!url.startsWith('http')) {
      return (
        <div className="profile-img-container">
          <Skeleton height="100%" width="100%" />
          {tagHTML}
        </div>
      );
    } else {
      return (
        <div
          className="profile-img-container"
          style={{ backgroundImage: `url(${url})` }}
        >
          {tagHTML}
        </div>
      );
    }
  }

  getPersonalProfilePhoto = (url) => {
    if (!url) {
      return <div className="personal-profile-img" style={{ backgroundImage: `url(${DefaultProfile})` }} />;
    }
    if (!url.startsWith('http')) {
      return (
        <div className="personal-profile-img">
          <Skeleton circle height="100%" width="100%" />
        </div>
      );
    } else {
      return <div className="personal-profile-img" style={{ backgroundImage: `url(${url})` }} />;
    }
  }

  renderUserTile = (email) => {
    const user = this.props.users[email];
    const { answers, name } = user;
    const year = answers.year_of_graduation?.answer;
    const location = this.props.user.userType === 1 ? answers.house?.answer : answers.location?.answer;
    const bio = answers.bio?.answer;
    const img = answers.profile_photo?.answer;
    const tags = [];
    const potentialTagCategories = {
      how_messy: ['Clean', 'Messy'],
      bed_time: ['Sleeps early', 'Night owl'],
      going_out: ['Stays in', 'Partier'],
    };
    Object.keys(potentialTagCategories).forEach((tag) => {
      const tagOptions = potentialTagCategories[tag];
      if (answers[tag]?.answer < 0) tags.push(tagOptions[0]);
      else if (answers[tag]?.answer > 0) tags.push(tagOptions[1]);
    });

    return (
      <div
        className="profile-container"
        onClick={() => this.props.goToProfile(this.props.history, email, this.goToFeed)}
        key={name}
      >
        {this.getFeedProfilePhoto(img, tags)}
        <div className="profile-description-container">
          <div className="profile-line-1">
            <h2 className="profile-header">{name}</h2>
            <div>
              <button
                className="match-button"
                type="button"
                onClick={async (e) => {
                  e.stopPropagation();
                  try {
                    await this.props.postMatch(email);
                    await this.props.getMatches();
                  } catch (error) {
                    console.log(error);
                  }
                }}
              >
                {
                email in this.props.usersRecip
                  ? <><img src={Check} alt="check" /> Matched</>
                  : email in this.props.usersNoRecip
                    ? <><img src={Check} alt="check" /> Requested</>
                    : 'Match'
                }
              </button>
            </div>
          </div>
          <h2 className="profile-subheader">{`'${year !== undefined ? year.slice(2) : 'N/A'} – ${location}`}</h2>
          <p>{bio}</p>
        </div>
      </div>
    );
  }

  renderEmpty() {
    return (
      <div className="noneFoundContainer">
        <h3 className="no-results">No Results Found</h3>
        <p className="sorry">Sorry, looks like we couldn’t find anyone. Try searching or filtering for someone else!</p>
        <div>
          <img className="lookin" src={lookinMan} alt="lookinMan" />
        </div>
      </div>
    );
  }

  render() {
    if (this.state.loading) {
      return (
        <SkeletonCard />
      );
    }
    const locationKey = this.props.user.userType === 1 ? 'house' : 'location';
    return (
      <div className="feed-container">
        <div className="filters-feed">
          <div className="filters-container">
            <Filter />
          </div>
          {this.props.feedLoading
            ? <LoadingCard />
            : (
              <div className="profiles-container">
                {Object.keys(this.props.users)?.length ? Object.keys(this.props.users).map(u => this.renderUserTile(u)) : this.renderEmpty()}
              </div>
            )
          }
        </div>
        <div className="dashboard-container">
          {this.getPersonalProfilePhoto(this.props.questions?.profile_photo?.answer)}
          <h2 className="profile-header center-text">{this.props.user.name}</h2>
          <h2 className="profile-subheader center-text">Class of {this.props.questions?.year_of_graduation?.answer} – {this.props.questions?.[locationKey]?.answer}</h2>
          <div className="summary-stats-container">
            <div className="summary-stat-box" onClick={() => this.props.history.push('/matches')}>
              <h1>{Object.keys(this.props.usersRecip).length}</h1>
              <p>Matches</p>
            </div>
            <div className="summary-stat-box" onClick={() => this.props.history.push('/matches')}>
              <h1>{this.props.numRequests}</h1>
              <p>Want to Match</p>
            </div>
            <div className="summary-stat-box" onClick={() => this.props.history.push('/matches')}>
              <h1>{Object.keys(this.props.usersNoRecip).length}</h1>
              <p>Outgoing Matches</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Feed;
